import { render, staticRenderFns } from "./LoginTrabajador2.vue?vue&type=template&id=60a1003b&scoped=true"
import script from "./LoginTrabajador2.vue?vue&type=script&lang=js"
export * from "./LoginTrabajador2.vue?vue&type=script&lang=js"
import style0 from "./LoginTrabajador2.vue?vue&type=style&index=0&id=60a1003b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a1003b",
  null
  
)

export default component.exports